





































import { Vue, Component, Lifecycle, Prop, p } from "av-ts";

import QuestionService from "../../services/QuestionService";
import PageLoader from "../util/PageLoader.vue";
import Question from "./Question.vue";
import { IQuestion } from "../../interfaces/models";
import ActionButtons from "../util/ActionButtons.vue";
import AdminButtons from "../util/AdminButtons.vue";

@Component({
    components: {
        Question,
        PageLoader,
        AdminButtons,
        ActionButtons
    }
})

export default class QuestionWrapper extends Vue {
    @Prop id = p<number>({
        required: true
    });
    
    @Prop returnTo = p<string>({
        default: "answer"
    });

    @Prop loadUserID = p<string>({});

    @Prop reportCount = p<string>({});

    canEdit: boolean = false;

    pQuestion: IQuestion | undefined = undefined;

    returnToPrevious() {
        let query:any = {};
        if (this.loadUserID) {
            query.loadUserID = this.loadUserID;
        }
        if (this.reportCount) {
            query.reportCount = this.reportCount;
        }
        this.$router.push({ name: this.returnTo, query: query });
    }

    updateQuestion() {
        QuestionService.getQuestionById(this.id)
            .then((question: IQuestion | undefined) => {
                this.pQuestion = question;
                if (this.pQuestion && this.pQuestion.canEdit !== undefined && this.pQuestion.canEdit) {
                    this.canEdit = true;
                }
            });
    }

    get question() {
        return this.pQuestion;
    }

    openDialog() {
        (<Question> this.$refs.questionComponent).openDialog();
    }

    editQuestion() {
        let query:any = {};
        if (this.loadUserID) {
            query.loadUserID = this.loadUserID;
        }
        if (this.reportCount) {
            query.reportCount = this.reportCount;
        }
        this.$router.push({
            name: "edit",
            params: {
                returnTo: this.returnTo || "answer",
                id: this.id.toString()
            },
            query: query
        });
    }

    returnToBrowse() {
        this.$router.push({ name: "answer" });
    }

    @Lifecycle
    created() {
        this.updateQuestion();
    }


}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/questions/QuestionWrapper.vue